import { render } from "./TimelineScrollhint.vue?vue&type=template&id=62b8bf48&ts=true"
import script from "./TimelineScrollhint.vue?vue&type=script&lang=ts"
export * from "./TimelineScrollhint.vue?vue&type=script&lang=ts"

import "./TimelineScrollhint.vue?vue&type=style&index=0&id=62b8bf48&lang=scss"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__